/*
 * -----------------------------------------------------------------------
 *  <copyright file="add-library-control/review-frequency.tsx" company="Triumph Research Intelligence">
 *      Copyright (C) 2023 by Triumph Research Intelligence. All rights reserved.
 *  </copyright>
 * -----------------------------------------------------------------------
 */

import { FormHelperText } from '@mui/material';
import FormControl from '@mui/material/FormControl';
import cn from 'clsx';
import React from 'react';
import { useTranslation } from '../../../../hooks';
import SelectWithCategories from '../../core/select-with-categories';
import { SelectWithSearchDataArrayInterface } from '../../core/select-with-categories/select-with-categories.interface';
import { AddLibraryControlErrors, AddLibraryControlFieldProps } from './add-library-control.interface';
import './styles.scss';

interface AddLibraryControlReviewFrequencyProps extends AddLibraryControlFieldProps {
    reviewFrequencyTypeOptions: SelectWithSearchDataArrayInterface[];
    reviewFrequencyUnitOptions: SelectWithSearchDataArrayInterface[];
    errors: AddLibraryControlErrors;
}

const AddLibraryControlReviewFrequency = ({
    state,
    onChange,
    className,
    reviewFrequencyTypeOptions,
    reviewFrequencyUnitOptions,
    errors,
}: AddLibraryControlReviewFrequencyProps) => {
    const { t } = useTranslation();

    return (
        <div className={cn('type-edc-wrapper', className)}>
            <FormControl variant="outlined" className="form-control-type mr">
                <SelectWithCategories
                    customClassName="reviewFrequencyUnits"
                    fieldSelect="reviewFrequencyUnits"
                    onChange={onChange}
                    // Period and unit labels are deliberately switched round in the UI as they are incorrectly named in the API
                    label={t('ra:reviewFrequencyPeriod')}
                    filterable={false}
                    labelField="reviewFrequencyUnits"
                    dataArray={reviewFrequencyTypeOptions}
                    customId="add-library-control-frequency-period"
                    currentState={state.reviewFrequencyUnits}
                />
                <FormHelperText className="error-text">{errors.reviewFrequencyUnits}</FormHelperText>
            </FormControl>
            <FormControl variant="outlined" className="form-control-type">
                <SelectWithCategories
                    customClassName="edit-control-review-frequency-units"
                    showWarning={false}
                    fieldSelect="reviewFrequencyNumber"
                    onChange={onChange}
                    // Period and unit labels are deliberately switched round in the UI as they are incorrectly named in the API
                    label={t('ra:reviewFrequencyUnits')}
                    filterable={false}
                    labelField="reviewFrequencyNumber"
                    dataArray={reviewFrequencyUnitOptions}
                    customId="add-library-control-review-frequency-units"
                    currentState={state.reviewFrequencyNumber}
                />
                <FormHelperText className="error-text">{errors.reviewFrequencyNumber}</FormHelperText>
            </FormControl>
        </div>
    );
};

export default AddLibraryControlReviewFrequency;
